import { IServerInfoRes } from '@/interfaces/misc';
import * as baseAdapter from './baseAdapter';

export const getServerInfo = async () => {
  const ret = await baseAdapter.get<IServerInfoRes>(`/v1/misc/server-info`);
  return ret;
};
